import * as yup from 'yup';
import {
  STATUS_PROCESSED,
  STATUS_INITIATED,
  STATUS_PENDING,
  STATUS_CANCELLED,
  STATUS_IN_TRANSIT,
  STATUS_FAILED,
} from './helpers';
import { multiSelectValidation } from 'components/PaymentFilter/defaultFilters.schema';

export const FIELD_NAMES = {
  statusCheckbox: 'statusCheckbox',

  paid: STATUS_PROCESSED,
  cancelled: STATUS_CANCELLED,
  initiated: STATUS_INITIATED,
  failed: STATUS_FAILED,
  in_transit: STATUS_IN_TRANSIT,
  pending: STATUS_PENDING,
};
export const defaultValues = (currentFilters) => {
  const statusFilters = currentFilters.status
    ? new Set(currentFilters.status.split(','))
    : new Set();

  return {
    [FIELD_NAMES.statusCheckbox]: currentFilters.statusCheckbox,
    status: {
      [FIELD_NAMES.paid]: statusFilters.has(FIELD_NAMES.paid) ? true : false,
      [FIELD_NAMES.cancelled]: statusFilters.has(FIELD_NAMES.cancelled)
        ? true
        : false,
      [FIELD_NAMES.initiated]: statusFilters.has(FIELD_NAMES.initiated)
        ? true
        : false,
      [FIELD_NAMES.failed]: statusFilters.has(FIELD_NAMES.failed)
        ? true
        : false,
      [FIELD_NAMES.in_transit]: statusFilters.has(FIELD_NAMES.in_transit)
        ? true
        : false,
      [FIELD_NAMES.pending]: statusFilters.has(FIELD_NAMES.pending)
        ? true
        : false,
    },
  };
};

const statusValidation = multiSelectValidation(FIELD_NAMES.statusCheckbox);

const schema = yup.object().shape({
  [FIELD_NAMES.paid]: statusValidation,
  [FIELD_NAMES.cancelled]: statusValidation,
  [FIELD_NAMES.initiated]: statusValidation,
  [FIELD_NAMES.failed]: statusValidation,
  [FIELD_NAMES.in_transit]: statusValidation,
  [FIELD_NAMES.pending]: statusValidation,
});

export default schema;
